import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  DashboardIntro,
  MyActionButton,
  MyButton,
  PhoneInput,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [hashtags, setHashtags] = useState("");
  const [musicStatus, setMusicStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const [repeatEvery, setRepeatEvery] = useState(null);
  const [expo, setExpo] = useState(0);
  const [pricing, setPricing] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [venue, setVenue] = useState(null);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [venueCapacity, setVenueCapacity] = useState(null);
  const [email, setEmail] = useState(null);
  const [payLink, setPayLink] = useState(null);

  const musicRoutes = "/data/music";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setExpo(0);
    setHashtags("none");
    setDescription(null);
    setRepeatEvery(null);
    setPricing([]);
    setPayLink(null);
  };

  const responses = (error, message) => {
    setError(error);
    setLoading(false);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const addOneMusicHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      hashtag: `${tags}, ${hashtags}`,
      status: musicStatus,
      repeat_every: repeatEvery,
      expo: expo,
      pricing: pricing,
      venue: venue,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      featured: featured,
      promoted: promoted,
      venue_capacity: venueCapacity,
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.MUSIC,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  // ——— design tokens (style-only) ———
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-5";
  const sectionTitle = "text-sm font-semibold text-slate-900";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: musicRoutes }} />
        </div>

        <div className="mb-6">
          <DashboardIntro props={{ intro: `Add Music`, name: entry_label }} />
        </div>

        <form onSubmit={addOneMusicHandler} className="space-y-5">
          <div className={`${card}`}>
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="flex items-center justify-between">
              <Title props={{ title: "Cover Image" }} />
            </div>
            <div className="mt-3">
              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={image_kit_folder(country_name, FOLDERS.MUSIC)}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Concert Details" }} />
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  required: true,
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "venue",
                  title: "Venue",
                  type: "text",
                  value: venue ? venue : "",
                  onChange: (e) => {
                    setVenue(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "venue_capacity",
                  title: "Venue Capacity",
                  type: "number",
                  value: venueCapacity ? venueCapacity : "",
                  onChange: (e) => {
                    setVenueCapacity(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "formatted_address",
                  title: "Formatted Address",
                  type: "address",
                  value: formattedAddress ? formattedAddress : "",
                  onChange: (e) => {
                    setFormattedAddress(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Pricing" }} />
            <div className="mt-4">
              <Pricing pricing={pricing} setPricing={setPricing} />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <p className={sectionTitle}>Repeat Every</p>
            <div className="mt-3 flex flex-wrap gap-6 text-sm">
              {[
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday",
                "annual",
              ].map((val, i) => (
                <div key={i} className="flex items-center gap-2 capitalize">
                  <span className="min-w-[80px]">{val}</span>
                  {repeatEvery?.toString().split("|").includes(val) ? (
                    <MdCheckBox
                      onClick={() => {
                        let rep = "";
                        repeatEvery
                          ?.split("|")
                          .filter((day) => val !== day)
                          .map((weekday) => (rep += `${weekday}|`));
                        setRepeatEvery(rep);
                      }}
                      className="text-2xl cursor-pointer"
                    />
                  ) : (
                    <MdCheckBoxOutlineBlank
                      onClick={() => {
                        let rep = "";
                        if (repeatEvery) {
                          [...repeatEvery.split("|"), val].map(
                            (weekday) => (rep += `${weekday}|`)
                          );
                          setRepeatEvery(rep);
                        } else {
                          setRepeatEvery(val);
                        }
                      }}
                      className="text-2xl cursor-pointer"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Date & Time" }} />
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "start_date",
                  title: "Start Date",
                  type: "date",
                  value: startDate ? startDate : "",
                  onChange: (e) => {
                    setStartDate(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "end_date",
                  title: "End Date",
                  type: "date",
                  value: endDate ? endDate : "",
                  onChange: (e) => {
                    setEndDate(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "start_time",
                  title: "Start Time",
                  type: "time",
                  value: startTime ? startTime : "",
                  onChange: (e) => {
                    setStartTime(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "end_time",
                  title: "End Time",
                  type: "time",
                  value: endTime ? endTime : "",
                  onChange: (e) => {
                    setEndTime(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="flex flex-row justify-center items-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Social Contact" }} />
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp ? whatsapp : "",
                  onChange: (e) => {
                    setWhatsapp(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Faceparty",
                  type: "text",
                  value: facebook ? facebook : "",
                  onChange: (e) => {
                    setFacebook(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter ? twitter : "",
                  onChange: (e) => {
                    setTwitter(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram ? instagram : "",
                  onChange: (e) => {
                    setInstagram(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube ? youtube : "",
                  onChange: (e) => {
                    setYoutube(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Geo Position" }} />
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
              <InputField
                props={{
                  id: "google_map_code",
                  title: "Google Map Code",
                  type: "text",
                  value: googleMapCode ? googleMapCode : "",
                  onChange: (e) => {
                    setGoogleMapCode(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "latitude",
                  title: "Latitude",
                  type: "text",
                  value: latitude ? latitude : "",
                  onChange: (e) => {
                    setLatitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "longitude",
                  title: "Longitude",
                  type: "text",
                  value: longitude ? longitude : "",
                  onChange: (e) => {
                    setLongitude(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "More Settings" }} />
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <Select
                props={{
                  id: "music_status",
                  title: "Status",
                  required: true,
                  option: ["visible", "invisible"],
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setMusicStatus(1);
                    else setMusicStatus(0);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "featured",
                  title: "Featured",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setFeatured(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    const choice = e.target.value;
                    setExpo(choice === "no" ? 0 : 1);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="flex items-center justify-between">
              <Title props={{ title: "Description" }} />
              <MyButton
                onClick={() => setShowDescriptionModal(true)}
                className="bg-blue-700 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
              >
                Generate Description
              </MyButton>
            </div>
            <div className="mt-4">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags ? hashtags : "",
                  onChange: (e) => {
                    setHashtags(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="flex justify-end">
              <MyActionButton
                loading={loading}
                title="Add Music"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}
    </div>
  );
};

export default Add;
